import { Injectable } from '@angular/core';
import { ApiService, PageData, ReadonlyRepositoryImpl } from '@eceos/arch';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CuritibaSpecialTaxationRegime } from '../special-taxation-regime';

@Injectable({ providedIn: 'root' })
export class CuritibaSpecialTaxationRegimeRepository extends ReadonlyRepositoryImpl<
  CuritibaSpecialTaxationRegime,
  CuritibaSpecialTaxationRegime
> {
  constructor(api: ApiService) {
    super(
      api.root.path('fiscal/settings/nfes/curitibaTaxations'),
      CuritibaSpecialTaxationRegime,
      CuritibaSpecialTaxationRegime
    );
  }

  getFirst(): Observable<CuritibaSpecialTaxationRegime> {
    return this.page(new PageData(0, 1)).pipe(map((value) => (value ? value[0] : null)));
  }
}
